<template>
  <div>
    <tab-filters :tabs="tabs" @selected="selectedTab = $event.value" />
    <company-form :is-active.sync="isAdding" @added="companyAdded" />
    <data-table
      :headers="headers"
      title="Companies"
      companyFilter="true"
      :url="url"
      ref="table"
      @click:row="showDetails"
      @filter-changed="updateFilters"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          Create Company
          <v-icon class="ml-2" color="light-blue lighten-4">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <template slot="item.name" slot-scope="{ item }">
        {{ item.name | title }}
      </template>
      <template slot="item.type" slot-scope="{ item }">
        {{ item.type | title }}
      </template>
      <template slot="item.owner" slot-scope="{ item }">
        {{ extractDataKey(item, "owner.full_name") | title }}
      </template>

      <template slot="item.verified" slot-scope="{ item }">
        <v-icon color="success" v-if="item.verified_at">
          mdi-progress-check
        </v-icon>
        <v-icon color="warning" v-else> mdi-information-outline</v-icon>
      </template>

      <!-- <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_active">
          mdi-shield-check
        </v-icon>
        <v-icon color="warning" v-else> mdi-information-outline</v-icon>
      </template> -->
      <template slot="item.activated_at" slot-scope="{ item }">
        <v-icon color="success" v-if="item.activated_at">
          mdi-shield-check
        </v-icon>
        <v-icon color="warning" v-else> mdi-information-outline</v-icon>
      </template>
    </data-table>
  </div>
</template>
<script>
import TabFilters from "@/components/TabFilters";
import CompanyForm from "./form.vue";
export default {
  components: {
    TabFilters,
    CompanyForm,
  },
  data() {
    return {
      filters: {
       country: '',
       location: '',
       owner: '',
      },
      selectedTab: "all",
      isAdding: false,
      headers: this.pairTableLabelWithValue({
        "Created On": "created_at",
        // Id: "id",
        "Company Name": "name",
        "Owner Full Name": "owner",
        Country: "country",
        Address: "location",
        Verified: "verified",
        // Status: "status",
        Activated: "activated_at",
      }),
      tabs: [
        { name: "All", value: "all", icon: "mdi-view-list" },
        { name: "New", value: "new", icon: "mdi-clock-check-outline" },
        { name: "Active", value: "active", icon: "mdi-progress-check" },
        { name: "Verified", value: "verified", icon: "mdi-shield-check" },
      ],
    };
  },
  computed: {
    url() {
      const params = new URLSearchParams({
        [this.selectedTab]: true,
        sort_by: 'created_at',
        desc: true,
        ...this.filters,
      });
      return `api/v1/companies?${params.toString()}`;
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "companies.show", params: { id } });
    },
    companyAdded({ message }) {
      this.isAdding = false;
      this.$refs.table.fetchData();
      Notify.success(message);
    },

    updateFilters(newFilters) {
      const allowedFilters = ['country', 'location', 'owner'];
      this.filters = Object.fromEntries(
        Object.entries(newFilters).filter(([key]) => allowedFilters.includes(key))
      );
    },
  },

  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
};
</script>
